import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

/**
 * import services
 */
// import { LoginSelectionComponent, RedirectComponent, LandingComponent, MainComponent, StaffComponent, InstructionsComponent} from './';
import { LoginSelectionComponent } from './components/login-selection.component';
import { RedirectComponent } from './components/redirect.component';
import { LandingComponent } from './components/landing.component';
import { MainComponent } from './components/main.component';
import { LoginService } from './services/login.service';
import { InstructionsComponent } from '../instructions';
import { StaffComponent } from '../staff';
import { LoginGuardService } from './services/login-guard.service';
import { PaperSetComponent } from '../paper-sets/components/paper-set.component';
import { StatisticsComponent } from '../statistics/statistics.component';

/**
 * Login Route Configuration
 */
const loginRoutes: Routes = [
  {
    path: '',
    redirectTo: '/',
    pathMatch: 'full'
  },
  { path: '', component: MainComponent,data: {title: 'grade 5'},
          children: [{ path: '', component: LandingComponent },
                     { path: 'help', component: InstructionsComponent },
                     { path: 'aboutus', redirectTo: '/home/arts' }]
  },
  { path: 'auth/:register', redirectTo: '/'},
  { path: 'externalauth/:_type', component: RedirectComponent },
  { path: 'externalauth/access_token/:_token', component: RedirectComponent },
  { path: 'mobile/:access_token/payment', component: RedirectComponent },
];

export const loginRoutingProviders: any[] = [
  LoginService,
  LoginGuardService,
  TranslateService];

export const loginRouting: ModuleWithProviders = RouterModule.forChild(loginRoutes);



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/login/login.routes.ts